var map = {
	"./ContentSlider/Burger": [
		260,
		9
	],
	"./ContentSlider/Burger.tsx": [
		260,
		9
	],
	"./ContentSlider/ContentSlider": [
		320,
		9
	],
	"./ContentSlider/ContentSlider.tsx": [
		320,
		9
	],
	"./ContentSlider/Slide": [
		323,
		9
	],
	"./ContentSlider/Slide.tsx": [
		323,
		9
	],
	"./ContentSlider/chaptersBar": [
		305,
		9
	],
	"./ContentSlider/chaptersBar.style": [
		322,
		9
	],
	"./ContentSlider/chaptersBar.style.ts": [
		322,
		9
	],
	"./ContentSlider/chaptersBar.tsx": [
		305,
		9
	],
	"./ContentSlider/contentSlider.style": [
		199,
		9
	],
	"./ContentSlider/contentSlider.style.ts": [
		199,
		9
	],
	"./ContentSlider/vb_intro.svg": [
		2837,
		9,
		806
	],
	"./ContentSlider/vb_outro.svg": [
		2838,
		9,
		807
	],
	"./Cover": [
		507,
		9,
		0,
		1,
		3,
		4,
		58
	],
	"./Cover/": [
		507,
		9,
		0,
		1,
		3,
		4,
		58
	],
	"./Cover/CoverWrapper": [
		852,
		9,
		492
	],
	"./Cover/CoverWrapper.tsx": [
		852,
		9,
		492
	],
	"./Cover/IEbuttons": [
		929,
		9,
		392
	],
	"./Cover/IEbuttons.tsx": [
		929,
		9,
		392
	],
	"./Cover/cover.style": [
		1254,
		9,
		493
	],
	"./Cover/cover.style.ts": [
		1254,
		9,
		493
	],
	"./Cover/index": [
		507,
		9,
		0,
		1,
		3,
		4,
		58
	],
	"./Cover/index.tsx": [
		507,
		9,
		0,
		1,
		3,
		4,
		58
	],
	"./Footer": [
		352,
		9,
		173
	],
	"./Footer/": [
		352,
		9,
		173
	],
	"./Footer/footer.style": [
		872,
		9,
		494
	],
	"./Footer/footer.style.ts": [
		872,
		9,
		494
	],
	"./Footer/index": [
		352,
		9,
		173
	],
	"./Footer/index.tsx": [
		352,
		9,
		173
	],
	"./HOC/withHover": [
		167,
		9
	],
	"./HOC/withHover.css": [
		756,
		7
	],
	"./HOC/withHover.tsx": [
		167,
		9
	],
	"./ImageModule": [
		351,
		9,
		8,
		27
	],
	"./ImageModule/": [
		351,
		9,
		8,
		27
	],
	"./ImageModule/index": [
		351,
		9,
		8,
		27
	],
	"./ImageModule/index.tsx": [
		351,
		9,
		8,
		27
	],
	"./InteractivePanelTitle/InteractivePanelTitle": [
		819,
		9,
		424
	],
	"./InteractivePanelTitle/InteractivePanelTitle.tsx": [
		819,
		9,
		424
	],
	"./InteractivePanelTitle/interactivePanelTitle.style": [
		815,
		9,
		495
	],
	"./InteractivePanelTitle/interactivePanelTitle.style.ts": [
		815,
		9,
		495
	],
	"./Intro": [
		508,
		9,
		124
	],
	"./Intro/": [
		508,
		9,
		124
	],
	"./Intro/index": [
		508,
		9,
		124
	],
	"./Intro/index.tsx": [
		508,
		9,
		124
	],
	"./Intro/introPage.style": [
		1255,
		9,
		496
	],
	"./Intro/introPage.style.ts": [
		1255,
		9,
		496
	],
	"./LoadingSpinner": [
		188,
		9
	],
	"./LoadingSpinner/": [
		188,
		9
	],
	"./LoadingSpinner/index": [
		188,
		9
	],
	"./LoadingSpinner/index.tsx": [
		188,
		9
	],
	"./LoadingSpinner/spinner.svg": [
		600,
		9
	],
	"./Logo": [
		509,
		9,
		174
	],
	"./Logo/": [
		509,
		9,
		174
	],
	"./Logo/index": [
		509,
		9,
		174
	],
	"./Logo/index.style": [
		1256,
		9,
		497
	],
	"./Logo/index.style.ts": [
		1256,
		9,
		497
	],
	"./Logo/index.tsx": [
		509,
		9,
		174
	],
	"./NextChapterCover": [
		510,
		9,
		103
	],
	"./NextChapterCover/": [
		510,
		9,
		103
	],
	"./NextChapterCover/Loader": [
		324,
		9
	],
	"./NextChapterCover/Loader.tsx": [
		324,
		9
	],
	"./NextChapterCover/index": [
		510,
		9,
		103
	],
	"./NextChapterCover/index.tsx": [
		510,
		9,
		103
	],
	"./NextChapterCover/nextChapterCover.style": [
		1257,
		9,
		498
	],
	"./NextChapterCover/nextChapterCover.style.ts": [
		1257,
		9,
		498
	],
	"./Overlay": [
		190,
		9
	],
	"./Overlay/": [
		190,
		9
	],
	"./Overlay/index": [
		190,
		9
	],
	"./Overlay/index.tsx": [
		190,
		9
	],
	"./Overlay/overlay.style": [
		321,
		9
	],
	"./Overlay/overlay.style.ts": [
		321,
		9
	],
	"./Section/Section": [
		1176,
		9,
		393
	],
	"./Section/Section.tsx": [
		1176,
		9,
		393
	],
	"./Section/SectionStickyBackground": [
		1020,
		9,
		425
	],
	"./Section/SectionStickyBackground.tsx": [
		1020,
		9,
		425
	],
	"./Section/SectionTextContent": [
		998,
		9,
		394
	],
	"./Section/SectionTextContent.tsx": [
		998,
		9,
		394
	],
	"./Section/SectionTitle": [
		886,
		9,
		426
	],
	"./Section/SectionTitle.tsx": [
		886,
		9,
		426
	],
	"./Section/SectionWrapper": [
		327,
		9
	],
	"./Section/SectionWrapper.tsx": [
		327,
		9
	],
	"./Section/section.style": [
		832,
		9,
		499
	],
	"./Section/section.style.ts": [
		832,
		9,
		499
	],
	"./TabsContainer": [
		387,
		9,
		155
	],
	"./TabsContainer/": [
		387,
		9,
		155
	],
	"./TabsContainer/Tab": [
		1375,
		9,
		427
	],
	"./TabsContainer/Tab.tsx": [
		1375,
		9,
		427
	],
	"./TabsContainer/TabsContainer.style": [
		979,
		9,
		500
	],
	"./TabsContainer/TabsContainer.style.ts": [
		979,
		9,
		500
	],
	"./TabsContainer/components/glossary": [
		511,
		9,
		90
	],
	"./TabsContainer/components/glossary/": [
		511,
		9,
		90
	],
	"./TabsContainer/components/glossary/Alphabet": [
		1259,
		9,
		428
	],
	"./TabsContainer/components/glossary/Alphabet.style": [
		1063,
		9,
		501
	],
	"./TabsContainer/components/glossary/Alphabet.style.ts": [
		1063,
		9,
		501
	],
	"./TabsContainer/components/glossary/Alphabet.tsx": [
		1259,
		9,
		428
	],
	"./TabsContainer/components/glossary/Glossary.style": [
		1260,
		9,
		502
	],
	"./TabsContainer/components/glossary/Glossary.style.ts": [
		1260,
		9,
		502
	],
	"./TabsContainer/components/glossary/icons/icon.svg": [
		2839,
		9,
		808
	],
	"./TabsContainer/components/glossary/icons/iconAlt.svg": [
		2840,
		9,
		809
	],
	"./TabsContainer/components/glossary/index": [
		511,
		9,
		90
	],
	"./TabsContainer/components/glossary/index.tsx": [
		511,
		9,
		90
	],
	"./TabsContainer/components/videogallery": [
		512,
		9,
		126
	],
	"./TabsContainer/components/videogallery/": [
		512,
		9,
		126
	],
	"./TabsContainer/components/videogallery/GalleryItem": [
		1376,
		9,
		0,
		1,
		3,
		4,
		237
	],
	"./TabsContainer/components/videogallery/GalleryItem.tsx": [
		1376,
		9,
		0,
		1,
		3,
		4,
		237
	],
	"./TabsContainer/components/videogallery/gallery.style": [
		1262,
		9,
		503
	],
	"./TabsContainer/components/videogallery/gallery.style.ts": [
		1262,
		9,
		503
	],
	"./TabsContainer/components/videogallery/galleryItem.style": [
		1261,
		9,
		504
	],
	"./TabsContainer/components/videogallery/galleryItem.style.ts": [
		1261,
		9,
		504
	],
	"./TabsContainer/components/videogallery/icons/icon.svg": [
		2841,
		9,
		810
	],
	"./TabsContainer/components/videogallery/icons/iconAlt.svg": [
		2842,
		9,
		811
	],
	"./TabsContainer/components/videogallery/index": [
		512,
		9,
		126
	],
	"./TabsContainer/components/videogallery/index.tsx": [
		512,
		9,
		126
	],
	"./TabsContainer/components/worksheets": [
		513,
		9,
		83
	],
	"./TabsContainer/components/worksheets/": [
		513,
		9,
		83
	],
	"./TabsContainer/components/worksheets/WorksheetItem": [
		1263,
		9,
		379
	],
	"./TabsContainer/components/worksheets/WorksheetItem.tsx": [
		1263,
		9,
		379
	],
	"./TabsContainer/components/worksheets/icons/icon.svg": [
		2843,
		9,
		812
	],
	"./TabsContainer/components/worksheets/icons/iconAlt.svg": [
		2844,
		9,
		813
	],
	"./TabsContainer/components/worksheets/index": [
		513,
		9,
		83
	],
	"./TabsContainer/components/worksheets/index.tsx": [
		513,
		9,
		83
	],
	"./TabsContainer/components/worksheets/worksheet.style": [
		1264,
		9,
		505
	],
	"./TabsContainer/components/worksheets/worksheet.style.ts": [
		1264,
		9,
		505
	],
	"./TabsContainer/components/worksheets/worksheetItem.style": [
		1064,
		9,
		506
	],
	"./TabsContainer/components/worksheets/worksheetItem.style.ts": [
		1064,
		9,
		506
	],
	"./TabsContainer/index": [
		387,
		9,
		155
	],
	"./TabsContainer/index.tsx": [
		387,
		9,
		155
	],
	"./TabsContainer/tab.style": [
		1258,
		9,
		507
	],
	"./TabsContainer/tab.style.ts": [
		1258,
		9,
		507
	],
	"./ThumbnailWithIcon": [
		396,
		9,
		175
	],
	"./ThumbnailWithIcon/": [
		396,
		9,
		175
	],
	"./ThumbnailWithIcon/index": [
		396,
		9,
		175
	],
	"./ThumbnailWithIcon/index.tsx": [
		396,
		9,
		175
	],
	"./ThumbnailWithIcon/thumbnailWithIcon.style": [
		1054,
		9,
		508
	],
	"./ThumbnailWithIcon/thumbnailWithIcon.style.ts": [
		1054,
		9,
		508
	],
	"./buttons/topBar/Close": [
		395,
		9,
		176
	],
	"./buttons/topBar/Close/": [
		395,
		9,
		176
	],
	"./buttons/topBar/Close/index": [
		395,
		9,
		176
	],
	"./buttons/topBar/Close/index.style": [
		1050,
		9,
		509
	],
	"./buttons/topBar/Close/index.style.ts": [
		1050,
		9,
		509
	],
	"./buttons/topBar/Close/index.tsx": [
		395,
		9,
		176
	],
	"./buttons/topBar/Legal": [
		514,
		9,
		105
	],
	"./buttons/topBar/Legal/": [
		514,
		9,
		105
	],
	"./buttons/topBar/Legal/index": [
		514,
		9,
		105
	],
	"./buttons/topBar/Legal/index.style": [
		1265,
		9,
		510
	],
	"./buttons/topBar/Legal/index.style.ts": [
		1265,
		9,
		510
	],
	"./buttons/topBar/Legal/index.tsx": [
		514,
		9,
		105
	],
	"./buttons/topBar/Meta": [
		515,
		9,
		142
	],
	"./buttons/topBar/Meta/": [
		515,
		9,
		142
	],
	"./buttons/topBar/Meta/index": [
		515,
		9,
		142
	],
	"./buttons/topBar/Meta/index.style": [
		1266,
		9,
		511
	],
	"./buttons/topBar/Meta/index.style.ts": [
		1266,
		9,
		511
	],
	"./buttons/topBar/Meta/index.tsx": [
		515,
		9,
		142
	],
	"./buttons/topBar/Share": [
		516,
		9,
		69
	],
	"./buttons/topBar/Share/": [
		516,
		9,
		69
	],
	"./buttons/topBar/Share/icons/share.svg": [
		2292,
		9,
		814
	],
	"./buttons/topBar/Share/icons/socialFacebook.svg": [
		2293,
		9,
		815
	],
	"./buttons/topBar/Share/icons/socialInstagram.svg": [
		2845,
		9,
		816
	],
	"./buttons/topBar/Share/icons/socialTwitter.svg": [
		2294,
		9,
		817
	],
	"./buttons/topBar/Share/index": [
		516,
		9,
		69
	],
	"./buttons/topBar/Share/index.style": [
		1267,
		9,
		512
	],
	"./buttons/topBar/Share/index.style.ts": [
		1267,
		9,
		512
	],
	"./buttons/topBar/Share/index.tsx": [
		516,
		9,
		69
	],
	"./common/ScrollPage": [
		153,
		9
	],
	"./common/ScrollPage.tsx": [
		153,
		9
	],
	"./common/cookieBanner/BannerOverlay": [
		1377,
		9,
		513
	],
	"./common/cookieBanner/BannerOverlay.tsx": [
		1377,
		9,
		513
	],
	"./common/cookieBanner/CookiesBanner": [
		313,
		9
	],
	"./common/cookieBanner/CookiesBanner.tsx": [
		313,
		9
	],
	"./common/cookieBanner/cookiesBanner.style": [
		319,
		9
	],
	"./common/cookieBanner/cookiesBanner.style.ts": [
		319,
		9
	],
	"./common/elements/HeaderTitle": [
		833,
		9,
		429
	],
	"./common/elements/HeaderTitle.tsx": [
		833,
		9,
		429
	],
	"./common/elements/ResponsiveImage": [
		818,
		9,
		514
	],
	"./common/elements/ResponsiveImage.tsx": [
		818,
		9,
		514
	],
	"./common/elements/buttons": [
		187,
		9
	],
	"./common/elements/buttons.tsx": [
		187,
		9
	],
	"./common/elements/headerTitle.style": [
		825,
		9,
		515
	],
	"./common/elements/headerTitle.style.ts": [
		825,
		9,
		515
	],
	"./common/elements/overlays/SmartSwipeOverlay": [
		246,
		9
	],
	"./common/elements/overlays/SmartSwipeOverlay.tsx": [
		246,
		9
	],
	"./common/legal/LegalButton": [
		953,
		9,
		516
	],
	"./common/legal/LegalButton.tsx": [
		953,
		9,
		516
	],
	"./common/legal/LegalButtonComponent": [
		1378,
		9,
		376
	],
	"./common/legal/LegalButtonComponent.tsx": [
		1378,
		9,
		376
	],
	"./common/legal/impressum/ImpressumContainer": [
		952,
		9,
		430
	],
	"./common/legal/impressum/ImpressumContainer.tsx": [
		952,
		9,
		430
	],
	"./common/legal/impressum/ImpressumContent": [
		1379,
		9,
		356
	],
	"./common/legal/impressum/ImpressumContent.tsx": [
		1379,
		9,
		356
	],
	"./common/legal/impressum/impressumContainer.style": [
		920,
		9,
		517
	],
	"./common/legal/impressum/impressumContainer.style.ts": [
		920,
		9,
		517
	],
	"./common/legal/legalButton.style": [
		896,
		9,
		518
	],
	"./common/legal/legalButton.style.ts": [
		896,
		9,
		518
	],
	"./common/scrollPage.style": [
		325,
		9
	],
	"./common/scrollPage.style.ts": [
		325,
		9
	],
	"./common/scrollSidebar": [
		517,
		9,
		97
	],
	"./common/scrollSidebar/": [
		517,
		9,
		97
	],
	"./common/scrollSidebar/ScrollSideBar": [
		326,
		9
	],
	"./common/scrollSidebar/ScrollSideBar.tsx": [
		326,
		9
	],
	"./common/scrollSidebar/index": [
		517,
		9,
		97
	],
	"./common/scrollSidebar/index.tsx": [
		517,
		9,
		97
	],
	"./common/scrollSidebar/scrollSideBar.style": [
		1047,
		9,
		519
	],
	"./common/scrollSidebar/scrollSideBar.style.ts": [
		1047,
		9,
		519
	],
	"./common/svg_paths/export_path_bg_quiz_v2.svg": [
		2846,
		9,
		818
	],
	"./common/svg_paths/paper.svg": [
		2093,
		9,
		819
	],
	"./common/video/SimpleVideoPlayer": [
		855,
		9,
		1,
		3,
		4,
		431
	],
	"./common/video/SimpleVideoPlayer.tsx": [
		855,
		9,
		1,
		3,
		4,
		431
	],
	"./common/video/videoContainer": [
		804,
		9,
		0,
		1,
		3,
		4,
		314
	],
	"./common/video/videoContainer.style": [
		805,
		9,
		520
	],
	"./common/video/videoContainer.style.ts": [
		805,
		9,
		520
	],
	"./common/video/videoContainer.tsx": [
		804,
		9,
		0,
		1,
		3,
		4,
		314
	],
	"./common/video/videoplayer": [
		802,
		9,
		0,
		1,
		3,
		4,
		357
	],
	"./common/video/videoplayer.style": [
		803,
		9,
		521
	],
	"./common/video/videoplayer.style.ts": [
		803,
		9,
		521
	],
	"./common/video/videoplayer.tsx": [
		802,
		9,
		0,
		1,
		3,
		4,
		357
	],
	"./factories/InlineSubcontentWidget": [
		264,
		9
	],
	"./factories/InlineSubcontentWidget.tsx": [
		264,
		9
	],
	"./factories/contentFactory": [
		255,
		9
	],
	"./factories/contentFactory.tsx": [
		255,
		9
	],
	"./factories/inlineSubcontentWidget.style": [
		315,
		9
	],
	"./factories/inlineSubcontentWidget.style.ts": [
		315,
		9
	],
	"./icons/arrowDown.svg": [
		259,
		9
	],
	"./icons/arrowLeft.svg": [
		400,
		9
	],
	"./icons/arrowLeftDark.svg": [
		596,
		9
	],
	"./icons/arrowRight.svg": [
		382,
		9
	],
	"./icons/arrowRightDark.svg": [
		597,
		9
	],
	"./icons/checkGreen.svg": [
		2181,
		9,
		820
	],
	"./icons/cross.svg": [
		261,
		9
	],
	"./icons/crossBlack.svg": [
		379,
		9
	],
	"./icons/crossDark.svg": [
		340,
		9
	],
	"./icons/crossRed.svg": [
		2182,
		9,
		821
	],
	"./icons/icon-social-facebook.svg": [
		2289,
		9,
		822
	],
	"./icons/icon-social-insta.svg": [
		2290,
		9,
		823
	],
	"./icons/icon-social-twitter.svg": [
		2288,
		9,
		824
	],
	"./icons/info.svg": [
		2218,
		9,
		825
	],
	"./icons/knowledge.svg": [
		2123,
		9,
		826
	],
	"./icons/menu.svg": [
		581,
		9
	],
	"./icons/menuClose.svg": [
		598,
		9
	],
	"./icons/metaMobile.svg": [
		2291,
		9,
		827
	],
	"./icons/scrollingArrow.svg": [
		599,
		9
	],
	"./icons/vertiefungArbeitsblatt.svg": [
		2164,
		9,
		828
	],
	"./icons/vertiefungsGallery.svg": [
		2119,
		9,
		829
	],
	"./icons/vertiefungsGraphics.svg": [
		2163,
		9,
		830
	],
	"./icons/vertiefungsImage.svg": [
		2102,
		9,
		831
	],
	"./icons/vertiefungsPause.svg": [
		2105,
		9,
		832
	],
	"./icons/vertiefungsPlay.svg": [
		2104,
		9,
		833
	],
	"./icons/vertiefungsText.svg": [
		2148,
		9,
		834
	],
	"./legal/impressum/ImpressumContainerList": [
		1380,
		9,
		432
	],
	"./legal/impressum/ImpressumContainerList.tsx": [
		1380,
		9,
		432
	],
	"./legal/impressum/impressumContainerList.style": [
		1268,
		9,
		522
	],
	"./legal/impressum/impressumContainerList.style.tsx": [
		1268,
		9,
		522
	],
	"./panels/Gallery": [
		1381,
		9,
		251
	],
	"./panels/Gallery.tsx": [
		1381,
		9,
		251
	],
	"./panels/Image": [
		1382,
		9,
		262
	],
	"./panels/Image.tsx": [
		1382,
		9,
		262
	],
	"./panels/PanelSlider": [
		1270,
		9,
		358
	],
	"./panels/PanelSlider.tsx": [
		1270,
		9,
		358
	],
	"./panels/Text": [
		1383,
		9,
		263
	],
	"./panels/Text.tsx": [
		1383,
		9,
		263
	],
	"./panels/Video": [
		1384,
		9,
		264
	],
	"./panels/Video.tsx": [
		1384,
		9,
		264
	],
	"./panels/gallery.style": [
		1269,
		9,
		433
	],
	"./panels/gallery.style.ts": [
		1269,
		9,
		433
	],
	"./panels/image.style": [
		1271,
		9,
		434
	],
	"./panels/image.style.ts": [
		1271,
		9,
		434
	],
	"./panels/panelSlider.style": [
		1065,
		9,
		435
	],
	"./panels/panelSlider.style.ts": [
		1065,
		9,
		435
	],
	"./panels/text.style": [
		1272,
		9,
		436
	],
	"./panels/text.style.ts": [
		1272,
		9,
		436
	],
	"./panels/video.style": [
		1273,
		9,
		437
	],
	"./panels/video.style.ts": [
		1273,
		9,
		437
	],
	"./topbar/TopBar": [
		328,
		9
	],
	"./topbar/TopBar.tsx": [
		328,
		9
	],
	"./topbar/TopBarButtons": [
		330,
		9
	],
	"./topbar/TopBarButtons.style": [
		331,
		9
	],
	"./topbar/TopBarButtons.style.ts": [
		331,
		9
	],
	"./topbar/TopBarButtons.tsx": [
		330,
		9
	],
	"./topbar/icon": [
		978,
		9,
		523
	],
	"./topbar/icon.tsx": [
		978,
		9,
		523
	],
	"./topbar/topBar.style": [
		329,
		9
	],
	"./topbar/topBar.style.ts": [
		329,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1677;
module.exports = webpackAsyncContext;